import { type IconProps, Stroke } from "./base";

/** The header's pages and the account menu. */

export function OverviewIcon({ strokeWidth = 1.7, ...props }: IconProps) {
    return (
        <Stroke strokeWidth={strokeWidth} {...props}>
            <rect x="3.5" y="3.5" width="7" height="7" rx="1.8" />
            <rect x="13.5" y="3.5" width="7" height="7" rx="1.8" />
            <rect x="3.5" y="13.5" width="7" height="7" rx="1.8" />
            <rect x="13.5" y="13.5" width="7" height="7" rx="1.8" />
        </Stroke>
    );
}

export function JobsIcon({ strokeWidth = 1.7, ...props }: IconProps) {
    return (
        <Stroke strokeWidth={strokeWidth} {...props}>
            <rect x="3" y="7" width="18" height="13" rx="2" />
            <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M3 12h18" />
        </Stroke>
    );
}

export function QueueIcon({ strokeWidth = 1.7, ...props }: IconProps) {
    return (
        <Stroke strokeWidth={strokeWidth} {...props}>
            <path d="M4 4.5h16v15H4zM4 13h4.5l2 3h3l2-3H20" />
        </Stroke>
    );
}

export function ResumeIcon({ strokeWidth = 1.7, ...props }: IconProps) {
    return (
        <Stroke strokeWidth={strokeWidth} {...props}>
            <path d="M7 3h7l5 5v13H7zM14 3v5h5M9.5 13h5M9.5 17h5" />
        </Stroke>
    );
}

export function EnvelopeIcon({ strokeWidth = 1.7, ...props }: IconProps) {
    return (
        <Stroke strokeWidth={strokeWidth} {...props}>
            <rect x="3" y="5" width="18" height="14" rx="2" />
            <path d="m3 7 9 6 9-6" />
        </Stroke>
    );
}

export function SignOutIcon({ strokeWidth = 1.8, ...props }: IconProps) {
    return (
        <Stroke strokeWidth={strokeWidth} {...props}>
            <path d="M15 4h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3M10 17l5-5-5-5M15 12H4" />
        </Stroke>
    );
}
